import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Award() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            「デーリー東北賞」「デーリー東北特別賞」とは
          </Typography>
          　「デーリー東北賞」は、北奥羽地方に住んでおられる方、またはその地方のご出身の方で、地方文化・産業・経済・学術・芸術・スポーツなどの各分野で卓越した功績のあった個人、団体をたたえるため、1971（昭和46）年に創設しました。<br/>
          　2008（平成20）年には、その年に輝かしい業績をあげた北奥羽地方ゆかりの個人・団体を顕彰する、「デーリー東北特別賞」を制定しました。<br/>
        </Box>

        <Box my={8}>
          ただいま更新中です。
          {/*
          <Typography className="font-weight-bold my-3 text-white bg-dark rounded px-3 py-1" variant="subtitle1" component="div">
            デーリー東北賞 ２個人１団体に贈呈（2024/12/14）
          </Typography>
          　北奥羽地方の文化や学術、産業、スポーツなどの分野で著しい功績のあった個人と団体をたたえる「第５３回デーリー東北賞」の贈呈式が１３日、八戸市のデーリー東北新聞社で行われ、受賞者が喜びを胸に今後のさらなる飛躍を誓った。<br />
          　デーリー東北賞を受賞したのは、長年八戸地方の歴史を調査研究している八戸歴史研究会会長の三浦忠司さん（７６）＝同市＝と、半世紀以上にわたり幼児教育に力を注ぐ千葉幼稚園名誉園長の千葉多香子さん（８６）＝同市＝、環境をテーマにしたさまざまな研究が世界大会でも高評価を受けている青森県立名久井農業高環境システム科環境研究班の２個人１団体。<br />
          <Box my={4} textAlign="center">
            <Grid spacing={4} container direction="row" justify="left" className="text-left">
              <Grid item xs={12} md={3}>
                <img src="/images/award/award-202401.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={9}>
                <Typography className="font-weight-bold my-1" variant="subtitle1" component="div">
                  【デーリー東北賞】<br />
                  長年、幼児教育振興に尽力　千葉多香子さん
                </Typography>
                　１９３８年１月、台湾・台南市生まれ。終戦により弘前市に移住。弘前大教育学部卒。６２年に千葉幼稚園赴任。副園長を経て、７９年に千葉幼稚園、第二千葉幼稚園、第三千葉幼稚園の３園の園長を歴任。八戸市私立幼稚園協会会長、青森県私立幼稚園連合会会長を務めた。２０１６年４月に第二、第三が千葉幼稚園に統合され、現職。
              </Grid>
            </Grid>
          </Box>
          <Box my={4} textAlign="center">
            <Grid spacing={4} container direction="row" justify="left" className="text-left">
              <Grid item xs={12} md={3}>
                <img src="/images/award/award-202402.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={9}>
                <Typography className="font-weight-bold my-1" variant="subtitle1" component="div">
                  【デーリー東北賞】<br />
                  八戸地域の歴史研究をリード　三浦忠司さん
                </Typography>
                　１９４８年２月、五戸町生まれ。弘前大教育学部卒。青森県立高教諭を経て、９８年から７年間、八戸市史編さん室長を務める。同市立美保野小中学校校長を最後に教員を退職。２００５年から八戸歴史研究会会長。０９年、安藤昌益資料館開館とともに館長に就任。著書に「八戸三社大祭の歴史」（八戸歴史研究会）、「八戸藩の歴史をたずねて」（デーリー東北新聞社）など。
              </Grid>
            </Grid>
          </Box>
          <Box my={4} textAlign="left">
            <Grid spacing={4} container direction="row" justify="left">
              <Grid item xs={12} md={4}>
                <img src="/images/award/award-202403.jpg" className="img-fluid" />
              </Grid>
              <Grid item xs={12} md={8}>
                <Typography className="font-weight-bold my-1" variant="subtitle1" component="div">
                  【デーリー東北賞】<br />
                  国内外で環境テーマに研究発表　青森県立名久井農業高環境システム科環境研究班
                </Typography>
                　２０１３年度の環境システム科開設に伴い、２、３年生の課題研究班として１４年度に発足。２０年には国際大会のストックホルム青少年水大賞でグランプリに輝いた。国内大会では２４年を含めて通算５度の最高賞を獲得している。国内学会が主催する各種コンテストでも多数の受賞歴を持つ。現在のメンバーは３年生７人、２年生３人。
              </Grid>
            </Grid>
          </Box>
          */}
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            これまでの受賞者
          </Typography>
          <Box my={4} textAlign="left">
            <Grid spacing={4} container direction="row" justify="left">
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第５３回（令和６年度）</dt>
                  <dd>
                    千葉多香子さん<br/>
                    三浦忠司さん<br/>
                    青森県立名久井農業高環境システム科環境研究班<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第５２回（令和５年度）</dt>
                  <dd>
                    上斗米正子さん<br/>
                    磯﨑元勝さん、司さん兄弟<br/>
                    八戸地方えんぶり連合協議会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第５１回（令和４年度）</dt>
                  <dd>
                    高橋みのる氏<br/>
                    日本うるし掻き技術保存会<br/>
                    デーリー東北特別賞（令和４年）<br/>
                    佐々木琢磨氏<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第５０回（令和３年度）</dt>
                  <dd>
                    栗村　知弘氏<br/>
                    青森県立八戸西高等学校文芸部<br/>
                    青森県立八戸高等学校文芸部<br/>
                    デーリー東北特別賞（令和３年）<br/>
                    天摩　由貴氏<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４９回（令和２年度）</dt>
                  <dd>
                    中川　慧梧氏<br/>
                    南部裂織保存会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４８回（令和元年度）</dt>
                  <dd>
                    平間　恵美氏<br/>
                    西里　俊文氏<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４７回（平成３０年度）</dt>
                  <dd>
                    高橋　弘希氏<br/>
                    伊藤　二子氏<br/>
                    苫米地　義之氏<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４６回（平成２９年度）</dt>
                  <dd>
                    対馬　ルリ子氏<br/>
                    はちのへ山車振興会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４５回（平成２８年度）</dt>
                  <dd>
                    澤内　和興氏<br/>
                    三沢市寺山修司記念館<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">デーリー東北特別大賞（平成２８年）</dt>
                  <dd>
                    伊調　馨選手<br/>
                    デーリー東北特別賞（平成２８年）<br/>
                    太田　忍選手<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４４回（平成２７年度）</dt>
                  <dd>
                    八戸市青葉湖展望交流施設「山の楽校」運営協議会<br/>
                    柾谷　伸夫氏<br/>
                    沼山　助内氏<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４３回（平成２６年度）</dt>
                  <dd>
                    大川　みほさん<br/>
                    八戸ポータルミュージアム「はっち」<br/>
                    青森県立三本木農業高校動物科学科愛玩動物研究室<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４２回（平成２５年度）</dt>
                  <dd>
                    藤木　倶子さん<br/>
                    青森県立田子高校郷土芸能部<br/>
                    八戸ホワイトベア<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４１回（平成２４年度）</dt>
                  <dd>
                    梅内　美華子さん<br/>
                    八戸市立市民病院救命救急センター<br/>
                    はちのへ小さな浜の会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">デーリー東北特別賞</dt>
                  <dd>
                    【ロンドン五輪「金」】伊調　馨選手、小原　日登美選手<br/>
                    光星学院高等学校硬式野球部<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４０回（平成２３年度）</dt>
                  <dd>
                    久保田 政子さん（株）八戸フォーラム<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">デーリー東北特別賞</dt>
                  <dd>
                    光星学院高等学校硬式野球部<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３９回（平成２２年度）</dt>
                  <dd>
                    木附沢 麦青氏<br/>
                    八戸市読書団体連合会<br/>
                    八戸せんべい汁研究所<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３８回（平成２１年度）</dt>
                  <dd>
                    野田　公俊氏<br/>
                    洋野町しいたけ産業振興協議会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３７回（平成２０年度）</dt>
                  <dd>
                    加藤　憲曠氏<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">デーリー東北特別賞</dt>
                  <dd>
                    伊調　千春さん<br/>
                    伊調　馨さん<br/>
                    坂本　日登美さん<br/>
                    大井　利江・須恵子さん夫妻<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３６回（平成１９年度）</dt>
                  <dd>
                    豊島　弘尚氏<br/>
                    久慈琥珀（株）<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３５回（平成１８年度）</dt>
                  <dd>
                    大久保　直次郎氏<br/>
                    太子食品工業（株）<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３４回（平成１７年度）</dt>
                  <dd>
                    佐々木　月花さん<br/>
                    松田　萬吉氏<br/>
                    文集「はちのへ」編集委員会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３３回（平成１６年度）</dt>
                  <dd>
                    伊調　千春さん、伊調　馨さん<br/>
                    元大関・貴ノ浪関<br/>
                    池田　修一氏<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３２回（平成１５年度）</dt>
                  <dd>
                    矢田　邦子さん<br/>
                    橋本　武広氏<br/>
                    八戸俳諧倶楽部<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３１回（平成１４年度）</dt>
                  <dd>
                    中畑　文利氏（農鍛冶の伝統を守る）<br/>
                    新幹線八戸駅開業実行委員会<br/>
                    みちのくおどり親和会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３０回（平成１３年度）</dt>
                  <dd>
                    盛田　稔氏（地方史研究）<br/>
                    豊島　和子さん（現代舞踊）<br/>
                    名川チェリーセンター１０１人会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２９回（平成１２年度）</dt>
                  <dd>
                    小笠原　盛氏（元関脇青ノ里）<br/>
                    劇団「やませ」<br/>
                    光星学院高校硬式野球部<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２８回（平成１１年度）</dt>
                  <dd>
                    白鳥　省吾氏（子ども会育成）<br/>
                    片峰　日出男氏（教諭・音楽）<br/>
                    南郷ジャズフェスティバル実行委員会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２７回（平成１０年度）</dt>
                  <dd>
                    八戸市医師会<br/>
                    佐々木　竹見氏（騎手）<br/>
                    三本木　烈氏（木工研究家）<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２６回（平成９年度）</dt>
                  <dd>
                    鷹山　宇一氏（洋画家）<br/>
                    林　みどりさん（料理家）<br/>
                    和井田　登氏（写真家）<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２５回（平成８年度）</dt>
                  <dd>
                    菅原　都々子さん（歌手）<br/>
                    岡田　一二三氏（方言研究家）<br/>
                    八戸市民フィルハーモニー交響楽団<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２４回（平成７年度）</dt>
                  <dd>
                    中村　キヤさん（私学理事長）<br/>
                    苫米地　ウメさん（乳児院理事長）<br/>
                    カシオペアアカデミー<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２３回（平成６年度）</dt>
                  <dd>
                    福田　進氏（昆虫研究家）<br/>
                    正部家　種康氏（郷土史家）<br/>
                    田舎の味推進協議会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２２回（平成５年度）</dt>
                  <dd>
                    佐藤　嘉悦氏（郷土史家）<br/>
                    伊藤　千蔵氏（教諭・音楽）<br/>
                    小渡　恵利子氏（ソプラノ歌手）<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２１回（平成４年度）</dt>
                  <dd>
                    小泉　林之助氏（緑化運動推進）<br/>
                    沼田　一夫氏（教諭・新体操）<br/>
                    林　福蔵氏（農業）<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２０回（平成３年度）</dt>
                  <dd>
                    金子　善兵衛氏（郷土史家）<br/>
                    清野　耕司氏（教諭・バトン）<br/>
                    安藤　睦夫氏（作曲家）<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１９回（平成２年度）</dt>
                  <dd>
                    原　冨士男氏（外交官）<br/>
                    田高　昭二氏（湿原研究家）<br/>
                    八戸山車製作研究会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１８回（平成元年度）</dt>
                  <dd>
                    小井田　幸哉氏（郷土史家）<br/>
                    佐藤　亮一氏（翻訳家）<br/>
                    八戸市学校歯科医会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１７回（昭和６３年度）</dt>
                  <dd>
                    馬場　のぼる氏（漫画家）<br/>
                    すずかけ女声コーラス<br/>
                    青森県立三戸高校自然科学部<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１６回（昭和６２年度）</dt>
                  <dd>
                    岡本　正雄氏（漁協組合長）<br/>
                    佐藤　憲一氏（教諭・音楽）<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１５回（昭和６１年度）</dt>
                  <dd>
                    寺井　義弘氏（方言研究家）<br/>
                    佐藤　政五郎氏（方言研究家）<br/>
                    青森県立三沢商業高校珠算部<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１４回（昭和６０年度）</dt>
                  <dd>
                    千葉　一彦氏（建築デザイナー）<br/>
                    百石町スケート協会<br/>
                    青森県畜産試験場<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１３回（昭和５９年度）</dt>
                  <dd>
                    坂本　勉氏（自転車競技選手）<br/>
                    竹内　秀男氏（教諭音楽）<br/>
                    六戸町・七百青年団<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１２回（昭和５８年度）</dt>
                  <dd>
                    鈴木　登紀子さん（料理研究家）<br/>
                    小笠原　禅成氏（刀剣研師）<br/>
                    八戸苺生産組合<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１１回（昭和５７年度）</dt>
                  <dd>
                    河原木　勝歳氏（レスリング監督）<br/>
                    森　一彦氏（蝶研究家）<br/>
                    青森県立名久井農業高校気象観測部<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１０回（昭和５６年度）</dt>
                  <dd>
                    中村　松太郎氏（宮大工）<br/>
                    柏崎　克彦氏（柔道選手）<br/>
                    鮫神楽連中<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第９回（昭和５５年度）</dt>
                  <dd>
                    左舘　秀之助氏（作家）<br/>
                    清水　兼松氏（南部もぐり）<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">昭和５４年度</dt>
                  <dd>
                    該当なし<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第８回（昭和５３年度）</dt>
                  <dd>
                    堤　喜一郎氏（少年野球監督）<br/>
                    八戸俳句会<br/>
                    田子町農業協同組合<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第７回（昭和５２年度）</dt>
                  <dd>
                    河野　満氏（卓球選手）<br/>
                    八戸青年会議所<br/>
                    五戸町役場サッカー部<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第６回（昭和５１年度）</dt>
                  <dd>
                    夏堀　正元氏（作家）<br/>
                    八戸たばこ耕作組合<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第５回（昭和５０年度）</dt>
                  <dd>
                    岩舘　義博氏（リンゴ農家）<br/>
                    下田　栄子さん（モダンバレエ）<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第４回（昭和４９年度）</dt>
                  <dd>
                    鈴木　三成氏（弓道・錬士）<br/>
                    武士沢水稲生産組合<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第３回（昭和４８年度）</dt>
                  <dd>
                    立田川親方（元横綱鏡里）<br/>
                    森のおとぎ会・八戸童話会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第２回（昭和４７年度）</dt>
                  <dd>
                    小寺　隆韶氏（教諭・演劇）<br/>
                    三戸町体力推進協議会<br/>
                  </dd>
                </dl>
              </Grid>
              <Grid item xs={12} md={6}>
                <dl className="fs90 line150">
                  <dt className="my-1">第１回（昭和４６年度）</dt>
                  <dd>
                    三浦　哲郎氏（作家）<br/>
                    西山　正治氏（医学博士）<br/>
                  </dd>
                </dl>
              </Grid>
            </Grid>
          </Box>

        </Box>

      </div>
    </div>
  );
}

export default Award;
